import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';

interface NavigableRouter {
  navigate: (to: string) => void;
}

// Handles incoming Universal Links (iOS) / App Links (Android) once the app
// is wrapped for native — no-op on web, where normal browser navigation
// already handles turaq.kg URLs. See public/.well-known/ for the association
// files that make the OS route these URLs to the app in the first place.
export function initDeepLinks(router: NavigableRouter) {
  if (!Capacitor.isNativePlatform()) return;

  App.addListener('appUrlOpen', ({ url }) => {
    try {
      const parsed = new URL(url);
      const path = parsed.pathname + parsed.search + parsed.hash;
      if (path) router.navigate(path);
    } catch (err) {
      console.warn('deepLinks: failed to parse incoming URL', url, err);
    }
  });
}
